import { NextPageContext } from "next";

import NonprofitsPage from "src/pages/Nonprofit/NonprofitOnboardingSearch";
import { createGetServerSideProps } from "src/utilities/ssr/createGetServerSideProps";
import { withPropsDeserialization } from "src/utilities/ssr/withPropsDeserialization";

export const getServerSideProps = createGetServerSideProps(
  // eslint-disable-next-line @typescript-eslint/require-await
  async (ctx: NextPageContext) => {
    const referral = ctx.query.referral;

    return {
      props: typeof referral === "string" ? { referral } : {},
    };
  }
);

export default withPropsDeserialization(NonprofitsPage);
